import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { debounceTime, filter, Subscription } from 'rxjs';
import { InvalidFieldMessageService } from 'src/app/services/invalid-field-message/invalid-field-message.service';
import { InscricaoEstadualValidator } from 'src/app/validators/inscricao-estadual-validator';


@Component({
  selector: 'app-inscricao-estadual',
  templateUrl: './inscricao-estadual.component.html',
  styleUrls: ['./inscricao-estadual.component.scss']
})
export class InscricaoEstadualComponent implements OnInit, OnDestroy {

  get messageError() {
    return this.messageService;
  }

  @Input() controlName!: string;
  @Input() label!: string;
  form!: FormGroup;
  formControl_IE!: AbstractControl
  public UF?: string
  private valueChanges$!: Subscription;
  private valueUfChanges$?: Subscription;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private messageService: InvalidFieldMessageService) { }

  ngOnDestroy(): void {
    this.valueChanges$.unsubscribe();
    this.valueUfChanges$?.unsubscribe();
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control;
    this.formControl_IE = this.form.controls[this.controlName];
    this.detectValueChanges();
    this.watchUFChange();
  }

  hasSpecificValidation(): boolean {
    return this.UF ? InscricaoEstadualValidator.hasSpecificValidation(this.UF) : false;
  }

  detectValueChanges() {
    this.valueChanges$ = this.formControl_IE.valueChanges.pipe(
      debounceTime(500)
    ).subscribe((value: string) => {
      if (value && this.UF) {
        this.validateInscricaoEstadual(value);
      }
    });
  }

  onIEInput(): void {
    this.formControl_IE.updateValueAndValidity();
  }

  private validateInscricaoEstadual(value: string) {
    if (!this.UF) {
      this.removeAllIEErrors();
      return;
    }

    const validationResult = InscricaoEstadualValidator.validate(this.formControl_IE, this.UF);
    
    if (validationResult) {
      this.setValidationErrors(validationResult);
    } else {
      this.removeAllIEErrors();
    }
  }

  private setValidationErrors(errors: any) {
    this.removeAllIEErrors();
    const currentErrors = this.formControl_IE.errors || {};
    this.formControl_IE.setErrors({
      ...currentErrors,
      ...errors
    });
  }

  private removeAllIEErrors() {
    const currentErrors = this.formControl_IE.errors;
    if (currentErrors) {
      delete currentErrors['invalid-inscricao-estadual'];
      delete currentErrors['invalid'];
      
      const remainingErrors = Object.keys(currentErrors).length ? currentErrors : null;
      this.formControl_IE.setErrors(remainingErrors);
    }
  }

  private watchUFChange() {
    const stateControl = this.form.get('address')?.get('state');
    if (!this.UF && stateControl?.value) {
      this.UF = stateControl.value;
    }

    this.valueUfChanges$ = stateControl?.valueChanges
      .pipe(filter(uf => typeof uf === 'string' && uf.length === 2))
      .subscribe(uf => {
        this.UF = uf;

        if (this.formControl_IE.value) {
          this.validateInscricaoEstadual(this.formControl_IE.value);
          this.formControl_IE.markAsTouched({ onlySelf: true });
        }
      });
  }
}